import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
	avatarResponsiveCustom: {
		"@media (max-width: 425px)": {
			width: "35px",
			height: "35px",
		},
		"@media (max-width: 280px)": {
			width: "30px",
			height: "30px",
		},
	},
}));
